export default "__VITE_ASSET__DPIV7gZb__"